/*
 * Where the dashboards live.
 *
 *   /home                        the practice Home (Practice Manager)
 *   /clients/:clientId?tab=overview   the client Overview tab (Client Manager)
 *
 * The lawyer landing page after login is `/home`. No React or IO here so the
 * rules stay unit-testable.
 */
import { matchPath } from "react-router-dom";

export const HOME_PATH = "/home";

export const isHomePath = (pathname: string): boolean =>
  matchPath({ path: HOME_PATH, end: true }, pathname) !== null;
